module.exports = __webpack_public_path__ + "static/media/flagVeryUnhealthy.21262546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagVeryUnhealthy.svg
// module id = 894
// module chunks = 0